export const PositionType = {
  LEFT:  { name: "Izquierda", id: "0" },
  MIDDLE: { name: "Centro", id: "1" },
  RIGHT: { name: "Derecha", id: "2" },
};
